import { JSX } from 'react'
import { Stack, Text } from '~/components-v2'
import { StarRating } from './star-ratings'

type StarScale = 5 | 4.5 | 4

type StarRatingProps = {
  rating: StarScale
}

export const G2StarRating = ({ rating }: StarRatingProps) => {
  const getStars = (rating: StarScale) => {
    switch (rating) {
      case 4.5:
        return <StarRating.FourAndAHalf />
      case 4:
        return <StarRating.Four />
      default:
        return <StarRating.Five />
    }
  }
  return getStars(rating)
}

export type G2ReviewProps = {
  name: string
  position?: string
  image?: string
  // At some point we may show things that are not five stars?
  rating: StarScale
  reviewCopy: string | JSX.Element
  reviewLink: string
}

export type G2ReviewCardProps = {
  review: G2ReviewProps
  // Some times we want to hide the image avatar for certain pages
  hideAvatar?: boolean
}

export const G2ReviewCard = ({
  review,
  hideAvatar = false,
}: G2ReviewCardProps) => {
  const {
    name,
    position,
    image,

    rating,
    reviewCopy,
    reviewLink,
  } = {
    ...review,
  }
  return (
    <Stack className="g2-review-card" gap={4}>
      <Stack row as="header" justify="space-between" wrap="wrap" gap={2}>
        <Stack row className="avatar-and-name" align="center" gap={2}>
          {!hideAvatar && (
            <div className="avatar">
              {image ? (
                <img src={image} alt={`Photo of ${name}`} />
              ) : (
                name.charAt(0)
              )}
            </div>
          )}
          <Stack>
            <Text fontSize="xs"> {name}</Text>
            {position && <Text fontSize="xs">{position}</Text>}
          </Stack>
        </Stack>
        <Stack className="star-rating-container">
          <G2StarRating rating={rating} />
        </Stack>
      </Stack>
      {reviewCopy}
      <a href={reviewLink} target="_blank" rel="noreferrer">
        Read full review
      </a>
    </Stack>
  )
}
